import {Injectable} from '@angular/core';
import {Overlay} from '@angular/cdk/overlay';
import {LoadingComponent} from '../../views/service-parts/loading/loading.component';
import {ComponentPortal} from '@angular/cdk/portal';
import {Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  globalOverlay = this.overlay.create({
    hasBackdrop: true,
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    panelClass: 'loading-panel',
  });
  loadingComponent = new ComponentPortal(LoadingComponent);

  constructor(private overlay: Overlay) {
  }

  show(): void {
    if (!this.globalOverlay.hasAttached()) {
      const globalOverlaySubscription: Subscription = this.globalOverlay.attachments().subscribe(() => {
        globalOverlaySubscription.unsubscribe();

        // わずかに待ちを入れないと表示時のアニメーションが行われないためsetTimeoutで待ちを入れる
        setTimeout(() => {
          this.globalOverlay.addPanelClass('show');
        }, 1);
      });

      this.globalOverlay.attach(this.loadingComponent);
    }
  }

  hide(): void {
    if (this.globalOverlay.hasAttached()) {
      this.globalOverlay.removePanelClass('show');

      // 非表示CSSアニメーションが完了した後にdetachして要素を削除する
      setTimeout(() => {
        this.globalOverlay.detach();
      }, 300);
    }
  }
}
